import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DEFAULT_MAP_THEME, isMapThemeStyle, MapThemeStyleValue } from "./types";
import { createBaseSelector, registerSlice } from "shared/lib/redux";
import { MapStorage } from "shared/utils/storage.utils";

const readStoredTheme = (): MapThemeStyleValue => {
  const stored = MapStorage.get();
  return isMapThemeStyle(stored) ? stored : DEFAULT_MAP_THEME;
};

type MapThemeState = {
  style: MapThemeStyleValue;
};

const initialState: MapThemeState = {
  style: readStoredTheme(),
};

const mapThemeSlice = createSlice({
  name: "mapTheme",
  initialState,
  reducers: {
    setMapTheme: (state, action: PayloadAction<MapThemeStyleValue>) => {
      state.style = action.payload;
      MapStorage.set(action.payload);
    },
  },
});

const mapThemeBaseSelector = createBaseSelector(mapThemeSlice);

registerSlice([mapThemeSlice]);

export const mapThemeStore = {
  actions: mapThemeSlice.actions,
  selectors: {
    style: createSelector(mapThemeBaseSelector, (s) => s.style),
  },
};
